import React, { Component } from 'react';

import AccountMenu from '../Modules/AccountMenu'
import Aanvraag from '../Modules/AanvraagIndienen/Aanvraag'

class AccountIndienen extends Component {

  render() {
    return (
      <div className="route">
        <AccountMenu />
        <div className="grey-bg">
          <h1 className="pageTitle">
            Aanvragen
            </h1>
          <p>U wilt een toetsingsaanvraag registerconstructeur, registerontwerper of registertoetser a of b indienen.</p>
        </div>
        <div className="grey-bg">
          <Aanvraag />
        </div>
      </div>
    );
  }
}

export default AccountIndienen;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/AccountIndienen.js